/* eslint-disable camelcase */
export type T_FetchMethod = 'GET' | 'POST';

export interface I_FetchParams {
	method: T_FetchMethod;
	headers?: { [key: string]: string };
	body?: string;
}

export interface I_WPAjaxArgs {
	action: string;
	params?: { [key: string]: any };
	data?: { [key: string]: any };
}

export interface I_WPRestArgs {
	path: string;
	params?: { [key: string]: any };
	data?: { [key: string]: any };
}

type T_WPAjax = <ReturnData>(args: I_WPAjaxArgs) => Promise<ReturnData>;

const AJAX_ENDPOINT = '/wp-admin/admin-ajax.php';
const REST_ENDPOINT = '/wp-json/trevor/v1';

const objectToParams = (object: { [key: string]: any }) =>
	Object.entries(object)
		.map((entry) => entry.join('='))
		.join('&');

export const WPAjax: T_WPAjax = async ({
	action = '',
	params = {},
	data = {},
}) => {
	if (!action) {
		return Promise.resolve(null);
	}

	const url = [
		AJAX_ENDPOINT,
		objectToParams({
			action,
			...params,
		}),
	].join('?');

	const method = Object.keys(data).length ? 'POST' : 'GET';

	const headers = {
		'content-type': 'application/x-www-form-urlencoded',
	};

	const fetchParams: I_FetchParams = { method, headers };

	if (Object.keys(data).length) {
		fetchParams.body = objectToParams(data);
	}

	const response = await fetch(url, fetchParams);

	if (response.status >= 400) {
		throw {
			status: response.status,
			response: await response.text(),
		};
	}

	return await response.json();
};

export const WPRest = async ({
	path = '',
	params = {},
	data = {},
}: I_WPRestArgs) => {
	if (!path) {
		return Promise.resolve(null);
	}

	const url = [
		REST_ENDPOINT + path,
		objectToParams({
			...params,
		}),
	].join('?');

	const method = 'GET';

	const headers = {
		'content-type': 'application/x-www-form-urlencoded',
	};

	const fetchParams: I_FetchParams = { method, headers };

	if (Object.keys(data).length) {
		fetchParams.body = objectToParams(data);
	}

	const response = await fetch(url, fetchParams);
	return await response.json();
};
